import { renderClientMessage } from '../shared/messages';
import type { IntakeDetail } from '../shared/types';

export function MessagePreviews({
	intake,
	smsEnabled,
}: {
	intake: Pick<IntakeDetail, 'reminderLanguage' | 'clientDisplayName' | 'consultationAt'>;
	smsEnabled: boolean;
}) {
	const placeholderLink = 'https://private-link.example.invalid/client-questionnaire';
	const reminder = intake.consultationAt
		? renderClientMessage({
				type: 'consultation_reminder',
				channel: 'email',
				language: intake.reminderLanguage,
				clientName: intake.clientDisplayName,
				consultationAt: intake.consultationAt,
			})
		: null;
	return (
		<details className="message-previews">
			<summary>{smsEnabled ? 'Preview client email and text messages' : 'Preview client email messages'}</summary>
			<p>These previews use the approved wording. A real private link is inserted only when an invitation is sent.</p>
			{(['email', 'sms'] as const)
				.filter((channel) => channel === 'email' || smsEnabled)
				.map((channel) => {
					const message = renderClientMessage({
						type: 'invitation',
						channel,
						language: intake.reminderLanguage,
						clientName: intake.clientDisplayName,
						consultationAt: intake.consultationAt,
						privateUrl: placeholderLink,
					});
					return (
						<article className="message-preview" key={`invitation-${channel}`}>
							<h3>Invitation · {channel === 'email' ? 'Email' : 'Text'}</h3>
							{channel === 'email' && (
								<p>
									<strong>Subject:</strong> {message.subject}
								</p>
							)}
							<pre>{message.body}</pre>
						</article>
					);
				})}
			{reminder && (
				<article className="message-preview">
					<h3>Consultation reminder · Email · 24 hours before</h3>
					<p>
						<strong>Subject:</strong> {reminder.subject}
					</p>
					<pre>{reminder.body}</pre>
				</article>
			)}
		</details>
	);
}
